// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3gGay","label":"Section_label__2j53E","contentWrap":"Section_contentWrap__1-v4a","footer":"Section_footer__1X_jf","footerInner":"Section_footerInner__34DJH"};